import { type GroupedOptionsType } from '@atlaskit/select';

export enum TimeRadioOptions {
	WITHIN_THE_LAST = 'withinTheLast',
	BETWEEN = 'between',
}

export interface DateTimeValue {
	endDate: string;
	startDate: string;
}

export type EventCategoriesGroupType = GroupedOptionsType<{
	label: string;
	value: string;
}>;

export type ByokInformationProps = {
	isByokComplianceSettingEnabled: boolean;
	isByokCustomer: boolean;
};

export type TransitioningExperinceProps = {
	isInTransitioning: boolean;
} & ByokInformationProps;
